import { SxProps, Theme } from '@mui/material';
import { TextInput as AdminTextInput, TextInputProps as AdminTextInputProps } from 'react-admin';
import { fieldWidth } from 'themes/layout';

export type TextInputProps = AdminTextInputProps & { readOnly?: boolean; shrink?: boolean };

const defaultSx: SxProps<Theme> = {
  '&.MuiFormControl-root': {
    marginTop: 0,
    marginBottom: 0,
  },
  '& .MuiFormHelperText-root': {
    marginTop: 0,
  },
  ...fieldWidth.medium,
};

export const TextInput: React.FC<TextInputProps> = ({
  InputLabelProps,
  shrink = true,
  sx,
  ...restProps
}) => (
  <AdminTextInput
    InputLabelProps={{ shrink: shrink || undefined, ...InputLabelProps }}
    sx={{ ...defaultSx, ...sx }}
    {...restProps}
  />
);
